import React from 'react';
import  { Container, Row, Col, Card, Form, Button,  Breadcrumb } from 'react-bootstrap';
import Header from '../page-layout/header/Header';
import NavMenu from '../navigation/Navmenu';
import Footer from '../page-layout/footer/Footer';
import { useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import moment from 'moment';
import { CreateUser, GetRole, UpdateUser, GetUserById } from '../../utils/axios/UserApi';
import { GetOrganization } from '../../utils/axios/CompanyAPI';
import { TimerAlert, ConfirmAlert } from '../../utils/swtAlert';
import { GrokLoading } from '../page-layout/loading/Loading';
import { Decrypt } from '../../utils/Helper';
import { GetLookUps } from '../../utils/axios/LookUpAPI';

function UserDetail(props) {
    const [userInfo, setuserInfo] = useState(JSON.parse(Decrypt(sessionStorage.getItem('userInfo'))));
    const navigate = useNavigate();
    const location = useLocation();
    const [validated, setValidated] = useState(false);
    const [isUpdate, setIsUpdate] = useState();
    const [loading, setLoading] = useState(true);

    //Form Control Variables Starts..
    const [role, setRole] = useState([]);
    const [organizationTypeId, setOrganizationTypeId] = useState('');
    const [organizationTypeList, setOrganizationTypeList] = useState([]);
    const [organizationList, setOrganizationList] = useState([]);
    const [userName, setUserName ] = useState('');
    const [organizationId, setOrganizationId] = useState('');
    const [roleId, setRoleId] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [ContactNumber, setContactNumber] = useState('');
    const [isSuperAdmin, setIsSuperAdmin] = useState(false);
    const [isCollege, setIsCollege] = useState(false);
    const [isCompany, setIsCompany] = useState(false);
    const [confirmPasswordErr, setConfirmPasswordErr] = useState('');
    const [passwordMatch, setPasswordMatch] = useState(false);
    const [profilePicture, setProfilePicture] = useState("");
    const [progresspercent, setProgresspercent] = useState(0);
    const [numberSuccess, setNumberSuccess] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [numberError, setNumberError] = useState("");
    const [showRemoveButton, setShowRemoveButton] = useState(false);
    //Form Control Variables Ends..

    const confirmPasswordRef = useRef();

    const isValidContactNumber = (e) => /^[6-9][0-9]+$/.test(e);

    const setValuePhoneNumber = (evt) => {
        // Assuming setContactNumber sets the ContactNumber in the component's state
        setContactNumber(evt);

        if (isValidContactNumber(evt)) {
            setNumberSuccess(true);
            setNumberError("");
        } else {
            setNumberError("Number should start with 6, 7, 8, or 9");
            setNumberSuccess(false);
        }
    }

    function convertToBase64(e) {
        var file = e.target.files[0];
        if (file) {
            if (file.size <= 5 * 1024 * 1024) {
                var reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => {
                    setProfilePicture(reader.result);
                    setErrorMessage('');
                    setShowRemoveButton(false);
                };
                reader.onprogress = (e) => {
                     setProgresspercent(((e.loaded / e.total) * 100).toFixed());
                };
                reader.onerror = error => {
                    console.log("Error:", error);
                };
            } else {
                setErrorMessage("File size exceeds 5MB");
                setShowRemoveButton(true);
            }
        }
    }
    function removeFile() {
        setErrorMessage('');
        setShowRemoveButton(false);
        document.getElementById('profilepicture').value = null;
    }


    const handleSubmit = (event) => {
        if (event && event.preventDefault) {
            event.preventDefault();
            const form = event.currentTarget;

            if (form && form.checkValidity && form.checkValidity() === false) {
                event.stopPropagation();
                setValidated(true);
                return;
            }

            if (!isValidContactNumber(ContactNumber)) {
                setNumberError("Number should start with 6, 7, 8, or 9");
                return;
            }

            if (errorMessage === '') {
                if (!isUpdate && passwordMatch === true) {
                    saveUser();
                } else if (isUpdate) {
                    saveUser();
                }
            } else {
                console.log("Error: Profile picture size exceeds 5MB");
            }
        }
    }

    const handleConfirmPassword = (e) => {
        
        if (password.length && confirmPassword.length > 0) {
            if (password !== confirmPassword) {
                confirmPasswordRef.current.style.border = "1px solid red"
                confirmPasswordRef.current.style.boxShadow = "0px 0px 4px #e6707b"
                setConfirmPasswordErr("Passwords doesn't match");
                setPasswordMatch(false);
            }
    
            else {
                confirmPasswordRef.current.style.border = "1px solid green"
                confirmPasswordRef.current.style.boxShadow = "0px 0px 4px green"
                setConfirmPasswordErr("");
                setPasswordMatch(true);
            }
        }
        else {
            confirmPasswordRef.current.style.border = "1px solid lightgray"
            confirmPasswordRef.current.style.boxShadow = "none"
            setConfirmPasswordErr("");
            setPasswordMatch(false);
        }
    }
    const BackBtn = () => {
        navigate('/users', { state: { userid: null } });
    }
    const bindFormPreloadData = async () => {
        setLoading(true);
        var roleResponse = await GetRole();
        const roleFilter = roleResponse.data.filter(item => item.Name !== "Student");
        setRole(roleFilter);

        let orgTypePayload = {
            Type: 5
        }
        var orgType = await GetLookUps(orgTypePayload);
        setOrganizationTypeList(orgType.data);
        setLoading(false);
    }

    const orgTypeChanged = async (event) => {
        setOrganizationTypeId(event.target.value);

        if (event.target.value !== '') {
            let organizationPayload = {
                OrganizationType: event.target.value  
            }
            setLoading(true);
            var orgResponse = await GetOrganization(organizationPayload);
            setOrganizationList(orgResponse.data);
            setLoading(false);
            setOrganizationId("");
        }
        else {
            setOrganizationList([]);
        }
    }


    const saveUser = async () => {
        let userPayload = {
            OrganizationId: organizationId,
            RoleId: roleId,
            Name: userName,
            Email: email,
            Password: password,
            ContactNumber: ContactNumber,
            PhotoURL: profilePicture,
            CreatedBy: userInfo._id
        }   
        if (location.state.userid != null) {
            var response = await UpdateUser(userPayload, location.state.userid);
            if (response.message) {
                TimerAlert('User Creation Failed', 'Oops Something Went Wrong', 'error');
            }
            else {
                var delay = TimerAlert('success', 'User Updated Successfully', 'success');
                setTimeout(() => navigate("/users"), delay);
            }
        }
        else {
            var response = await CreateUser(userPayload);
            if(response.message) {
                TimerAlert('User Creation Failed', 'Email already used', 'error');
            }
            else {
                var delay = TimerAlert('success', 'User Created Successfully', 'success');
                setTimeout(() => navigate("/users"), delay);
            }
        }
    }

    const bindFormData = async () => {
        if (location.state.userid !=null) {
            var response = await GetUserById(location.state.userid);
            setRoleId(response.data.RoleId.Id);
            setOrganizationId(response.data.OrganizationId.Id);
            setUserName(response.data.Name);
            setEmail(response.data.Email);
            setPassword(response.data.Password);
            setContactNumber(response.data.ContactNumber);
            setProfilePicture(response.data.PhotoURL);
        }
    }
    const clearState = () => {
        setRoleId("");
        setOrganizationId("");
        setUserName("");
        setEmail("");
        setPassword("");
        setConfirmPassword("");
        setContactNumber("");
        setOrganizationTypeId('');
        setProfilePicture('');
        document.getElementById('profilepicture').value = "";
        setProgresspercent(0);
    };
    const clear = () => {
        ConfirmAlert("Do you want to clear this data!", 'Are you sure?', 'warning', 'Confirm')
        .then((result) => {
            if (result.isConfirmed) {
                clearState();
            }
        });
    };
    const addRefresh = () => {
        navigate('/home', {state: {userid: null}});
    }

    const handleUser = () => {
        navigate('/users', {state: {userid: null}});
    }
    useEffect(() => {
        if (!isUpdate) {
            handleConfirmPassword();  
        }
    }, [password, confirmPassword]);

    useEffect(() => {
        bindFormPreloadData();
        bindFormData();
        // getOrganization();
        if(location.state.userid != null){
            setIsUpdate(true);
        }
        else{
            setIsUpdate(false);
        }

        setTimeout(() => {
            document.getElementById('nav-dropdownSuperadmin').parentElement.classList.add('show');
            document.getElementById('nav-dropdownSuperadmin').nextSibling.classList.add('show'); 
            document.getElementById('nav-dropdownSuperadmin').nextSibling.children[3].classList.add('active');
        }, 300);
    }, [])

    return (
        <div className='page'>
        {loading ? <GrokLoading /> : ""}
            <NavMenu />
            <Header />

            <div className='page-wrapper'>
                <Container fluid>
                    {/* Start Page Header */}
                    <div className='page-header d-print-none'>
                        <Row className='g-2 align-items-center'>
                            <div>
                                <Breadcrumb className="custom-breadcrumb">
                                    <Breadcrumb.Item onClick={() => addRefresh()}> Home</Breadcrumb.Item>
                                    <Breadcrumb.Item onClick={() => handleUser()}> Users</Breadcrumb.Item>
                                    <Breadcrumb.Item active> User Detail</Breadcrumb.Item>
                                </Breadcrumb>
                            </div>
                            <Col>
                                {!isUpdate && <h2 className="page-title">Add user</h2>}
                                {isUpdate && <h2 className="page-title">Edit user</h2>}
                            </Col>
                            <Col lg={2} className="mb-1" >
                                <Form.Group >
                                    <button className='newBtn_style' onClick={() => BackBtn()}>
                                        <span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1.5em" width="1.5em" xmlns="http://www.w3.org/2000/svg"><path fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" d="M249.38 336L170 256l79.38-80m-68.35 80H342"></path><path fill="none" strokeMiterlimit="10" strokeWidth="32" d="M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"></path></svg></span>
                                        &nbsp;&nbsp;Back
                                    </button>
                                </Form.Group>
                            </Col>
                        </Row>
                    </div>
                    {/* End Page Header */}

                    <div className='py-3'>
                        <Row className='g-2 justify-content-center'>

                            <Col className='col-lg-10 mb-4'>
                                <Card className='card-hover-shadow'>
                                    <Card.Body>
                                        {/* <Card.Title className='fw-bold mb-3'>Add Student Information:</Card.Title> */}

                                        <Form noValidate validated={validated} onSubmit={handleSubmit}>
                                            <Row >
                                                <Col lg={12}>
                                                    <Form.Group className="mb-3" >
                                                        <Form.Label> <h4>Users Details</h4> </Form.Label>
                                                    </Form.Group>
                                                </Col><hr/>
                                                {!isUpdate && <Col lg={4}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label >Organization Type <em className="Required">*</em> </Form.Label>
                                                        <div className="col">
                                                        <Form.Select as="select" required value={organizationTypeId} onChange={orgTypeChanged} >
                                                            <option value={''}>Select</option>
                                                            {organizationTypeList.map(item => (
                                                                <option key={item._id} value={item._id}>{item.Name}</option>
                                                            ))}
                                                        </Form.Select>
                                                        <Form.Control.Feedback type="invalid">Organization Type is required</Form.Control.Feedback>
                                                        </div>
                                                    </Form.Group>
                                                </Col>}
                                                {!isUpdate && <Col lg={4}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label >Organization Name <em className="Required">*</em> </Form.Label>
                                                        <div className="col">
                                                        <Form.Select as="select" required value={organizationId} onChange={(e) => setOrganizationId(e.target.value)} >
                                                            <option value={''}>Select</option>
                                                            {organizationList.map(item => (
                                                                <option key={item._id} value={item._id}>{item.Name}</option>
                                                            ))}
                                                        </Form.Select>
                                                        <Form.Control.Feedback type="invalid">Organization Name is required</Form.Control.Feedback>
                                                        </div>
                                                    </Form.Group>
                                                </Col>}
                                                <Col lg={4}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label >User Name <em className="Required">*</em> </Form.Label>
                                                        <div className='col'>
                                                            <Form.Control type="text" id="Name" minLength={3} placeholder="Enter User Name" required value={userName} onChange={(e) => setUserName(e.target.value)}/>
                                                            <Form.Control.Feedback type="invalid">UserName is required </Form.Control.Feedback>
                                                        </div>
                                                    </Form.Group>
                                                </Col>
                                                <Col lg={4}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label >Role <em className="Required">*</em> </Form.Label>
                                                        <div className="col">
                                                        <Form.Select as="select" required value={roleId} onChange={(e) => setRoleId(e.target.value)} >
                                                            <option value={''}>Select</option>
                                                            {role.map(item => (
                                                                <option key={item._id} value={item._id}>{item.Name}</option>
                                                            ))}
                                                        </Form.Select>
                                                        <Form.Control.Feedback type="invalid">Role is required </Form.Control.Feedback>
                                                        </div>
                                                    </Form.Group>
                                                </Col>
                                                <Col lg={4}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label  >Email ID<em className="Required">*</em> </Form.Label>
                                                        <div className='col'>
                                                            <Form.Control className="form-group" type="email" id="email" placeholder="Enter your email" required value={email} onChange={(e) => setEmail(e.target.value)} />
                                                            <Form.Control.Feedback type="invalid">Email is required </Form.Control.Feedback>
                                                        </div>
                                                    </Form.Group>
                                                </Col>
                                                <Col lg={4}>
                                                    <Form.Label>Contact Number<em className="Required">*</em> </Form.Label>
                                                    <Form.Control type="numeric" minLength={10} maxLength="10" id="ContactNumber" placeholder="Enter Contact Number" required value={ContactNumber} onChange={(e) => setValuePhoneNumber(e.target.value)} />
                                                    {numberError && <div style={{ color: 'red' }}>{numberError}</div>}
                                                    <Form.Control.Feedback type="invalid">Contact Number is required </Form.Control.Feedback>
                                                </Col>
                                                {!isUpdate && <Col lg={4}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Password <em className="Required">*</em> </Form.Label>
                                                        <div className='col'>
                                                            <Form.Control type="password" placeholder="Enter your Password" required autoComplete="new-password" value={password} onChange={(e) => setPassword(e.target.value)}/>
                                                            <Form.Control.Feedback type="invalid">Password is required </Form.Control.Feedback>
                                                        </div>
                                                    </Form.Group>
                                                </Col>}
                                                {!isUpdate && <Col lg={4}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Confirm Password <em className="Required">*</em> </Form.Label>
                                                        <div className='col'>
                                                            <Form.Control ref={confirmPasswordRef} type="password" id="ConfirmPassword" placeholder="Enter your Confirm Password"  required value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)}/>
                                                            {passwordMatch && <span style={{ color: 'green' }}>Passwords Match</span>}
                                                            {!passwordMatch && <span style={{ color: 'red' }}>{confirmPasswordErr}</span>}
                                                            <Form.Control.Feedback type="invalid">Confirm Password is required</Form.Control.Feedback>
                                                        </div>
                                                    </Form.Group>
                                                </Col>}
                                                <Row className='mt-3'>
                                                <Col lg={4}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Profile Picture <span style={{color: '#058798', marginLeft: '0.9rem', fontSize: '0.80em'}}>( Only 5MB files allowed )</span></Form.Label>
                                                            <div className="col">
                                                                <Form.Control id='profilepicture' className="mb-2" accept=".jpg, .png, .jpeg, .gif, .bmp, .tif, .tiff|image/*" type="file" onChange={convertToBase64} />
                                                                <div className="d-flex justify-content-between align-items-center">{errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
                                                                {showRemoveButton && <Button variant='warning' type="button" size="sm" className="ml-auto" onClick={removeFile}>Remove</Button>}
                                                                </div></div>
                                                        </Form.Group>
                                                    </Col>
                                                    
                                                    <Col lg={4}>
                                                        <Form.Group className="mb-3" >
                                                            <Card style={{ width: '12rem' }}>
                                                                <Card.Body>
                                                                    {
                                                                        profilePicture  &&
                                                                        <Card.Img variant="top" alt='uploaded file' src={profilePicture} />
                                                                    }
                                                                </Card.Body>
                                                                {
                                                                    !profilePicture &&
                                                                    <Card.Footer>
                                                                        <div className='outerbar'>
                                                                            <div className='innerbar' style={{ width: `${progresspercent}%` }}>{progresspercent}%</div>
                                                                        </div>
                                                                    </Card.Footer>
                                                                }
                                                            </Card>
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <Row  className='mt-3'>
                                                    <Col xs={4}>
                                                        <Button variant="danger" type="button" size="sm" aria-label="small button" onClick={() => clear()}> Clear</Button>
                                                    </Col>
                                                    <Col>
                                                        <div className="d-flex gap justify-content-end">
                                                            <Button variant="success" size="sm" aria-label="small button" type="submit"> Save</Button>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Row>
                                        </Form>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </div>

                </Container>

                <Footer />
            </div>
        </div>
    )
}
export default UserDetail;